import { Image } from 'components/Image'

export const overlayTexteFr: {
  date: string
  type?: 'text' | 'title'
  data: OverlayData
}[] = [
  {
    date: '2021-03-01',
    data: {
      date: '1er mars 2021',
      title: 'Les antécédents',
      text: (
        <>
          Le scandale Greensill ébranle Credit Suisse. Dans le sillage de cette
          débâcle, la grande banque doit suspendre des fonds gérant 10 milliards
          de dollars. Le même mois, CS est frappé par l'effondrement du fonds
          spéculatif américain Archegos. Il en résulte des pertes de plusieurs
          milliards. L'action perd nettement de sa valeur.
        </>
      ),
      links: [
        {
          text: 'La débâcle de Greensill rattrape la finance suisse',
          href: '690233357655',
        },
        {
          text: 'Credit Suisse reconnaîtrait sa faute dans l’affaire Archegos',
          href: '846834723069',
        },
      ],
    },
  },

  {
    date: '2021-04-22',
    data: {
      date: '22 avril 2021',
      title: "Les pertes d'Archegos s'élèvent à 5 milliards",
      text: (
        <>
          CS annonce de nouvelles pertes dues à l'effondrement du hedge fund
          américain Archegos. «Pour le deuxième trimestre, nous nous attendons à
          une charge restante de 600 millions de francs», indique la banque. Les
          pertes s'élèvent ainsi à 5 milliards de francs.
        </>
      ),
      links: [
        {
          text: 'Credit Suisse, plombée par Greensill et Archegos, subit une perte',
          href: '401295588122',
        },
      ],
    },
  },
  {
    date: '2021-04-30',
    data: {
      date: '30 avril 2021',
      title: 'Urs Rohner se retire',
      text: (
        <>
          <Image
            src={require('./Images/rohner.jpg')}
            caption='Urs Rohner'
            source='photo: Iris C. Ritter (FuW)'
          />
          Après dix ans, le président de CS, Urs Rohner, tire sa révérence à la
          suite de la crise de Greensill et d'Archegos. L'assemblée générale
          élit António Horta-Osório pour lui succéder. Urs Rohner a perçu au
          total un salaire d'environ 42 millions de francs. Durant son mandat,
          la tendance boursière s'est inversée: le cours est passé de 35 à moins
          de 10 francs.
        </>
      ),
      links: [
        {
          text: 'Les dirigeants de Credit Suisse passent entre les gouttes',
          href: '930343828255',
        },
      ],
    },
  },
  {
    date: '2021-06-17',
    data: {
      date: '17 juin 2021',
      title: 'Des éloges et un avertissement de la BNS',
      text: (
        <>
          CS est «bien positionnée pour relever les défis de l'environnement
          actuel et soutenir l'économie réelle», écrit la BNS dans son rapport
          sur la stabilité financière 2021. Mais le potentiel de pertes de la
          banque resterait considérable dans des scénarios de turbulences.
        </>
      ),
      links: [
        {
          text: 'Les banques suisses ont renforcé leurs bases de capitaux',
          href: '781285902707',
        },
      ],
    },
  },
  {
    date: '2021-07-13',
    data: {
      date: '13 juillet 2021',
      title: 'Rétrogradation',
      text: (
        <>
          L'agence de notation Moody's abaisse la note de crédit de CS après les
          incidents concernant les fonds Greensill et la perte de plusieurs
          milliards avec le hedge fund Archegos. La note à long terme baisse
          d'un cran et passe à A1, contre Aa3 auparavant
        </>
      ),
    },
  },
  {
    date: '2021-07-26',
    data: {
      date: '26 juillet 2021',
      title: 'Soulagement après une affaire d’espionnage',
      text: (
        <>
          <Image
            src={require('./Images/kahn.jpg')}
            caption='Iqbal Khan'
            source='photo: Iris C. Ritter (FuW)'
          />
          Iqbal Khan et sa femme retirent leur plainte pénale pour menaces et
          contrainte. L'affaire couvait depuis l'automne 2019, lorsqu'il avait
          été révélé que CS avait fait suivre par des détectives son cadre
          supérieur Iqbal Khan, qui avait passé à UBS.
        </>
      ),
      links: [
        {
          text: 'Credit Suisse et un ancien banquier star soldent une affaire d’espionnage',
          href: '768440329604',
        },
      ],
    },
  },
  {
    date: '2021-11-01',
    data: {
      date: '1er novembre 2021',
      title: 'Nouveau superviseur en chef',
      text: (
        <>
          L'Autorité de surveillance des marchés financiers (FINMA) change de
          chef. Urban Angehrn, l'ancien chef des placements de l'assureur
          Zurich, dirigera désormais l'autorité. La FINMA reproche régulièrement
          à CS son manque de gestion des risques. Elle ne peut toutefois pas
          infliger d'amendes.
        </>
      ),
      links: [
        {
          text: 'António Horta-Osório quitte la présidence de Credit Suisse',
          href: '467882452886',
        },
      ],
    },
  },
  {
    date: '2022-01-17',
    data: {
      date: '17 janvier 2022',
      title: 'Démission du président',
      text: (
        <>
          <Image
            src={require('./Images/osorio.jpg')}
            caption='António Horta-Osório'
            source='photo: AFP PHOTO/Leon Neal'
          />
          Le président de CS, António Horta-Osório, trébuche sur des violations
          de règles de quarantaine. Il aurait enfreint des obligations de
          protection liées au Covid lors d'une visite au tournoi de tennis de
          Wimbledon. Il s'acquitte d'une amende de 2000 francs. Il est remplacé
          par l'ancien banquier d'UBS Axel Lehmann.
        </>
      ),
      links: [
        {
          text: 'António Horta-Osório quitte la présidence de Credit Suisse',
          href: '467882452886',
        },
      ],
    },
  },
  {
    date: '2022-02-22',
    data: {
      date: '22 février 2022',
      title: 'Immense fuite de données',
      text: (
        <>
          Des journaux reçoivent, de la part d'un lanceur d'alerte, les données
          de plus de 30’000 clients et clientes. Les médias révèlent que des
          criminels peuvent ouvrir des comptes auprès de CS ou les conserver
          même «lorsque la banque aurait pu savoir depuis longtemps qu'elle
          avait affaire à des criminels».
        </>
      ),
      links: [
        {
          text: 'La fuite de données «Suisse Secrets» frappe Credit Suisse au cœur',
          href: '480980625650',
        },
      ],
    },
  },
  {
    date: '2022-02-23',
    data: {
      date: '23 février 2022',
      title: 'Une affaire de fraude coûteuse',
      text: (
        <>
          Un tribunal des Bermudes condamne CS à 607 millions de dollars de
          dommages et intérêts. L'ancien conseiller bancaire Patrice Lescaudron
          avait détourné des centaines de millions auprès de riches clients
          comme le milliardaire géorgien Bidsina Ivanichvili.
        </>
      ),
    },
  },
  {
    date: '2022-04-20',
    data: {
      date: '27 avril 2022',
      title: 'Avertissement sur les bénéfices I',
      text: (
        <>
          CS annonce qu'elle restera dans le rouge au premier trimestre 2022.
          Elle doit augmenter les provisions pour d'anciens cas juridiques.
          Conséquence: les spéculations de rachat font leur apparition.
        </>
      ),
      links: [
        {
          text: 'Credit Suisse chamboule sa direction après un trimestre difficile',
          href: '369617679235',
        },
      ],
    },
  },
  {
    date: '2022-06-08',
    data: {
      date: '8 juin 2022',
      title: 'Avertissement sur les bénéfices II',
      text: (
        <>
          Les chiffres seront également dans le rouge au deuxième trimestre,
          prévient CS. Elle parle d'une «année de transition» pour 2022. Les
          rumeurs de rachats se renforcent, ce qui donne de l'élan à l'action.
        </>
      ),
    },
  },
  {
    date: '2022-06-28',
    data: {
      date: '28 juin 2022',
      title: 'Un nouvel optimisme',
      text: (
        <>
          28 juin 2022: Le patron de la banque Thomas Gottstein et sa nouvelle
          équipe de direction tentent de convaincre les actionnaires et la
          clientèle des progrès de la banque lors d'une conférence des
          investisseurs à Londres. Il s'agit, selon lui, de construire une
          nouvelle CS plus résistante et sans concurrence dans le domaine du
          service à la clientèle.
        </>
      ),
    },
  },
  {
    date: '2022-07-27',
    data: {
      date: '27 juillet 2022',
      title: 'Un nouveau changement à la tête de la banque',
      text: (
        <>
          <Image
            src={require('./Images/koerner.jpg')}
            caption='Ulrich Körner'
            source='photo: PD'
          />
          Peu avant que CS ne présente un résultat semestriel déplorable, le
          directeur de la banque Thomas Gottstein s'en va. Sous sa direction, la
          banque a subi les effondrements de Greensill et d'Archegos. Ulrich
          Körner devient le nouveau chef - une grande série d'économies
          s'ensuit.
        </>
      ),
      links: [
        {
          text: 'Thomas Gottstein quitte son poste de directeur chez Credit Suisse',
          href: '857549052944',
        },
      ],
    },
  },
  {
    date: '2022-08-11',
    data: {
      date: '11 août 2022',
      title: 'Un gros actionnaire double sa participation',
      text: (
        <>
          Harris Associates augmente sa participation dans CS à 10%. Les
          Américains devancent ainsi largement les autres gros actionnaires.
        </>
      ),
      links: [
        {
          text: 'CS-Grossaktionär Harris verdoppelt Beteiligung',
          href: '518220562207',
        },
      ],
    },
  },
  {
    date: '2022-10-03',
    data: {
      date: '3 octobre 2022',
      title: 'Un mémo crée la panique',
      text: (
        <>
          «J'espère que vous ne confondez pas l'évolution quotidienne de notre
          cours avec la forte position de la banque en termes de capital et de
          liquidités», écrit le patron de la banque Ulrich Körner dans un mémo.
          Il veut ainsi rassurer, mais au lieu de ça, il attise l'incertitude:
          qu'en est-il de la stabilité si le chef insiste autant sur ce point?
        </>
      ),
      links: [
        {
          text: 'Un document interne fait plonger l’action Credit Suisse',
          href: '793396369646',
        },
      ],
    },
  },
  {
    date: '2022-10-27',
    data: {
      date: '27 octobre 2022',
      title: 'La tempête se déchaîne - la clientèle est inquiète',
      text: (
        <>
          Sur les réseaux sociaux, les spéculations vont bon train sur l'avenir
          de la banque. Le cours de l'action fluctue.
        </>
      ),
      links: [
        {
          text: 'Le plan de Credit Suisse ne convainc qu’à moitié',
          href: '863108707007',
        },
      ],
    },
  },
  {
    date: '2022-11-23',
    data: {
      date: '23 novembre 2022',
      title: 'Avertissement sur les bénéfices III',
      text: (
        <>
          CS annonce que des clients et clientes ont retiré des fonds et prévoit
          une perte pour le dernier trimestre de l'année 2022. L'action
          s'effondre malgré l'approbation par les actionnaires d'une
          augmentation de capital de 4 milliards par les nouveaux gros
          actionnaires saoudiens.
        </>
      ),
      links: [
        {
          text: 'Feu vert des actionnaires à l’augmentation de capital de CS',
          href: '418523395907',
        },
      ],
    },
  },
  {
    date: '2023-01-18',
    data: {
      date: '18 janvier 2023',
      title: "Tentatives d'apaisement",
      text: (
        <>
          «Comme nous l'avons déjà dit, les sorties de fonds ont très fortement
          diminué», déclare le directeur de la banque Ulrich Körner dans une
          interview accordée en marge du WEF. Il l'avait déjà affirmé en
          décembre lors d'une interview. Or cette déclaration s’était révélée
          fausse, raison pour laquelle l'autorité de surveillance des marchés
          financiers est intervenue.
        </>
      ),
    },
  },
  {
    date: '2023-02-09',
    data: {
      date: '9 février 2023 ',
      title: 'Des pertes élevées et des investisseurs inquiets',
      text: (
        <>
          CS annonce une perte de plus de 7 milliards de francs pour 2022. En
          cause: des coûts élevés, des corrections de valeurs drastiques et le
          retrait des fonds des clients.
        </>
      ),
      links: [
        {
          text: 'Credit Suisse a perdu 7,4 milliards en 2022',
          href: '236450794271',
        },
      ],
    },
  },
  {
    date: '2023-03-06',
    data: {
      date: '6 mars 2023 ',
      title: 'Un gros actionnaire se débarrasse de CS',
      text: (
        <>
          L'un des principaux gros actionnaires de la banque, Harris Associates,
          vend toutes ses actions Credit Suisse et ne fait pas de cadeau au duo
          de direction.
        </>
      ),
    },
  },
  {
    date: '2023-03-09',
    data: {
      date: '9 mars 2023 ',
      title: 'Débâcle du rapport annuel',
      text: (
        <>
          À la surprise générale, CS reporte la publication de son rapport
          annuel. En cause: des questions de dernière minute de la part de
          l'autorité américaine des marchés financiers, la Securities and
          Exchange Commission (SEC). L'action perd à nouveau de la valeur.
        </>
      ),
    },
  },
  {
    date: '2023-03-13',
    data: {
      date: '11, 12, 13 mars 2023',
      title: 'La crise bancaire suit son cours aux États-Unis',
      text: (
        <>
          Aux États-Unis, deux banques se retrouvent en difficulté et sont
          fermées - la Silicon Valley Bank et la Signature Bank à New York,
          l'une des principales banques pour les cryptoentreprises. La situation
          rappelle la crise financière de 2007-2008. Les actions bancaires
          s'effondrent dans le monde entier.
        </>
      ),
      links: [
        {
          text: 'La chute de sa banque illustre la débâcle de la Silicon Valley',
          href: '493411130823',
        },
        {
          text: 'Les autorités américaines frappent fort pour protéger les dépôts',
          href: '408615744693',
        },
        {
          text: 'Panique après la plus grosse faillite bancaire aux États-Unis depuis',
          href: '878111963444',
        },
      ],
    },
  },
  {
    date: '2023-03-15',
    data: {
      date: '15 mars 2023 ',
      title: 'Les Saoudiens réagissent',
      text: (
        <>
          Le principal actionnaire, la Saudi National Bank, exprime sa confiance
          envers CS, mais ne veut plus injecter d'argent. L'action s'effondre à
          tel point qu'elle est partiellement suspendue du négoce.
        </>
      ),
      links: [
        {
          text: 'Les Bourses tremblent de nouveau sur la santé des banques',
          href: '947201459753',
        },
      ],
    },
  },
  {
    date: '2023-03-16',
    data: {
      date: '16 mars 2023 ',
      title: 'Crédit de la BNS',
      text: <>CS reçoit de la BNS une aide de 50 milliards de francs.</>,
      links: [
        {
          text: 'Credit Suisse emprunte 50 milliards de francs à la BNS',
          href: '313168762403',
        },
      ],
    },
  },
]
